import contentfulGql from 'js/lib/contentfulGql';

export const localeMapper = contentfulGql`#graphql
  query ArticleLocaleMapper($slug: String!, $preview: Boolean!) {
    articleLocaleMapperCollection(limit: 1, preview: $preview, where: { slug: $slug }) {
      items {
        defaultRegion
        referencesCollection(preview: $preview) {
          items {
            localizedCountryCode
            localizedLanguageCode
            sys {
              id
            }
          }
        }
      }
    }
  }
`;
